export const INBOUND_MAX_AGE = 65
export const OUTBOUND_MAX_AGE = 70
